import { api } from "./api";

export type ViolationType =
  | "DualScreenDetected"
  | "FullscreenExit"
  | "TabSwitch"
  | "WindowBlur"
  | "CameraDenied"
  | "CameraLost"
  | "CopyAttempt"
  | "PasteAttempt"
  | "RightClick"
  | "DevtoolsShortcut"
  | "HeartbeatLost";

export interface RecordViolationRequest {
  type: ViolationType;
  occurredAt: string;                      // ISO
  metadata?: Record<string, string>;
}

export interface RecordViolationResponse {
  violationId: string;
  totalViolations: number;
  penaltyTotal: number;
  terminal: boolean;
}

export const proctorApi = {
  reportViolation: (attemptId: string, body: RecordViolationRequest) =>
    api.post<RecordViolationResponse>(`/attempts/${attemptId}/violations`, body).then((r) => r.data),

  uploadSnapshot: (attemptId: string, jpeg: Blob, widthPx: number, heightPx: number) => {
    const fd = new FormData();
    fd.append("image", jpeg, `snap-${Date.now()}.jpg`);
    fd.append("widthPx", String(widthPx));
    fd.append("heightPx", String(heightPx));
    return api.post(`/attempts/${attemptId}/snapshots`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};
